export const environment = {
  production: false,
  projectConfiguration: {
    name: "POLIPUSH_DEMO",
    API_URL: "https://polipush.demo.api.testctsolution.it/api"
  },
  keys: {
    TinyMCE: "boqg39ohpzcc8jme5jt2focybafrja1frizyfdnt53fa7i6w"
  },
  biDomain: "https://bi.polipush.it",
  brand: {
    type: 'polipush',
    name: 'Polipush',
    theme: {
      primaryColor: '#3244b0',
      secondaryColor: '#0087fd',
      bgColor: '#01003d',
      logo: 'assets/images/logo/logo.svg',
      favicon: 'favicon.ico',
      loginBackground: 'assets/images/background/polipush-3D.jpg',
      extendedLogo: 'assets/images/logo/logo-extended.png',
      logoOnDark: false
    },
    ref: 'https://polipush.it'
  }
};
